import { useEffect, useMemo } from "react";
import ProjectionLoadState from "../ProjectionLoadState";
import { useProjectActions, useProjectContext } from "@contexts/projects";
import AccordionItem from "./AccordionItem";
import ServiceAccordion from "./ServiceAccordion";
import { useDashboardUIContext } from "@contexts/dashboardUI";

const SubstepAccordion = ({parent}) => {
  
  const { barChartDate } = useDashboardUIContext()
  const {activeProject: {_id, substeps = {}}, filterDates} = useProjectContext();
  const { loadSubsteps } = useProjectActions();

  useEffect(() => {
    if(_id) {
      loadSubsteps(parent, barChartDate);
    } 
  },[_id, filterDates, barChartDate])

  const stepSubsteps = useMemo(() => substeps[parent], [parent, substeps])

  return (
    <>
      <ProjectionLoadState
        level="substeps"
        parent={parent}
        isMissing={!stepSubsteps}
        onRetry={() => loadSubsteps(parent, barChartDate)}
      />
      {stepSubsteps?.map((item, index) => <AccordionItem key={index} item={item} type={"substep"} typeTitle={"Subetapa"} ChildAccordionComponent={ServiceAccordion}/>)}
    </>
  )
}

export default SubstepAccordion;
